const ENV_BANNERS: Record<string, { label: string; color: string }> = {
  development: { label: 'DEV', color: 'bg-error' },
  staging: { label: 'STAGE', color: 'bg-success-green' },
  test: { label: 'TEST', color: 'bg-info' },
};

export function getEnvBannerLabel(env: string | undefined): string | null {
  if (!env) return null;
  return ENV_BANNERS[env]?.label ?? null;
}

type EnvBannerProps = {
  env?: string;
};

export function EnvBanner({ env = import.meta.env.VITE_APP_ENV }: EnvBannerProps) {
  const banner = env ? ENV_BANNERS[env] : undefined;
  if (!banner) return null;

  return (
    <div
      data-testid="env-banner"
      role="status"
      aria-label={banner.label}
      className="pointer-events-none fixed right-0 top-0 z-50 h-20 w-20 overflow-hidden"
    >
      <span
        className={`absolute -right-11 top-3 w-32 rotate-45 py-0.5 text-center text-2xs font-semibold leading-heading tracking-wide text-true-white ${banner.color}`}
      >
        {banner.label}
      </span>
    </div>
  );
}
